import { render, staticRenderFns } from "./g-icon.vue?vue&type=template&id=5eab00d8&scoped=true"
import script from "./g-icon.vue?vue&type=script&lang=js"
export * from "./g-icon.vue?vue&type=script&lang=js"
import style0 from "./g-icon.vue?vue&type=style&index=0&id=5eab00d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eab00d8",
  null
  
)

export default component.exports